import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { PivotTemplates } from '../../../backend/backendapi';

@Component({
    name: 'SelectTemplateModal',
    components: {}
})
export default class SelectTemplateModal extends Vue {
    @Prop({ required: true })
    readonly templates!: PivotTemplates;
    @Prop({ required: true })
    readonly templatesSharedOwn!: PivotTemplates;
    @Prop({ required: true })
    readonly templatesSharedOther!: PivotTemplates;

    selectedTab: 'own' | 'shared' = 'own';

    openModal(): void {
        $(this.$refs.modal!).modal('show');
    }

    closeModal(): void {
        $(this.$refs.modal!).modal('hide');
    }

    private get removeWhenPivotCompletelyInVue(): object {
        return { opacity: 1 };
    }

    private get removeWhenPivotCompletelyInVue2(): object {
        return { transform: 'unset' };
    }

    private get hasTemplates(): boolean {
        return !!this.templates?.templates?.length;
    }

    private get hasTemplatesSharedOwn(): boolean {
        return !!this.templatesSharedOwn?.templates?.length;
    }

    private get hasTemplatesSharedOther(): boolean {
        return !!this.templatesSharedOther?.templates?.length;
    }
}